import Vue from "vue";
import { firestore } from "firebase/app";
import { ClientDeviceRow } from "@/data/models/ClientAdministrationRow";
import { getLastUpdateText, IresDeviceStatus } from "@/data/models/IresDevice";
import { EMPTY_VALUE } from "@/utils/ClientAdministrationDetail";

/**
 * A portal device row's last contact ("IoT vor 2 h"), through the HyDry device list's own formatter;
 * "–" for a device that never reported. Shared by the client's Geräte list and its Sensordaten-Export.
 * It is the device's own status, so for a former device it may be a contact made at another client.
 */
export function clientDeviceLastContactText(vue: Vue, now: Date, device: ClientDeviceRow): string {
  if (!device.lastStatus) {
    return EMPTY_VALUE;
  }

  const status = {
    createdAt: firestore.Timestamp.fromMillis(device.lastStatus.createdAtMillis),
    source: device.lastStatus.source ?? undefined,
    lastPingReceivedAt:
      device.lastStatus.lastPingMillis === null
        ? undefined
        : firestore.Timestamp.fromMillis(device.lastStatus.lastPingMillis),
  } as unknown as IresDeviceStatus;

  return getLastUpdateText(vue, now, status, true);
}
